<template>
  <v-sheet>
    <v-alert border="bottom" border-color="#8BC34A" v-if="title" class="d-flex justify-center rounded-b-0 rounded-t-xl">
      <v-chip variant="text" color="#8BC34A" class="font-weight-bold" style="font-size: 20px;">{{ title }}</v-chip>
    </v-alert>
    <VueDatePicker
        :inline="{ input: true }"
        :teleport="true"
        ref="dp" locale="ru-RU"
        v-model="selected_cal" :range="range"
        :week-picker="weekPicker"
        :format="formatDate"
        @update:model-value="handleDate"
        select-text="ВЫБРАТЬ"
        cancel-text="ЗАКРЫТЬ"
        :placeholder="range ? 'Выбор периода' : 'Выбор даты'"
        :enable-time-picker="false"
    >
      <template #right-sidebar>
        <v-sheet v-if="range && !weekPicker">
          <div class="d-flex justify-center align-center">
            <v-chip variant="text">Готовые временные промежутки</v-chip>
          </div>
          <v-btn density="compact" block class="mb-1" :variant="isSelected('m_current') ? 'flat' : 'text'" flat :color="isSelected('m_current') ? 'light-green' : 'black'"  v-on:click="makeDate('m_current')">Текущий месяц</v-btn>
          <v-btn density="compact" block class="mb-1" :variant="isSelected('m_prev') ? 'flat' : 'text'" flat :color="isSelected('m_prev') ? 'light-green' : 'black'"  v-on:click="makeDate('m_prev')">Предыдущий месяц (Отчётный)</v-btn>
          <v-row no-gutters class="mb-1">
            <v-col cols="3">
              <v-btn density="compact" block :variant="isSelected('q_1') ? 'flat' : 'text'" :color="isSelected('q_1') ? 'light-green' : 'black'" v-on:click="makeDate('q_1')">К I</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn density="compact" block :variant="isSelected('q_2') ? 'flat' : 'text'" :color="isSelected('q_2') ? 'light-green' : 'black'" v-on:click="makeDate('q_2')">К II</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn density="compact" block :variant="isSelected('q_3') ? 'flat' : 'text'" :color="isSelected('q_3') ? 'light-green' : 'black'" v-on:click="makeDate('q_3')">К III</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn density="compact" block :variant="isSelected('q_4') ? 'flat' : 'text'" :color="isSelected('q_4') ? 'light-green' : 'black'" v-on:click="makeDate('q_4')">К IV</v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="mb-1">
            <v-col cols="6">
              <v-btn density="compact" block :variant="isSelected('hy_1') ? 'flat' : 'text'" :color="isSelected('hy_1') ? 'light-green' : 'black'" v-on:click="makeDate('hy_1')">ПОЛУГОДИЕ I</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn density="compact" block :variant="isSelected('hy_2') ? 'flat' : 'text'" :color="isSelected('hy_2') ? 'light-green' : 'black'" v-on:click="makeDate('hy_2')">ПОЛУГОДИЕ II</v-btn>
            </v-col>
          </v-row>
          <v-btn density="compact" block class="mb-1" :variant="isSelected('year-now') ? 'flat' : 'text'" :color="isSelected('year-now') ? 'light-green' : 'black'" v-on:click="makeDate('year-now')">С начала текущего года</v-btn>
          <v-btn density="compact" block class="mb-1" :variant="isSelected('year-prev') ? 'flat' : 'text'" :color="isSelected('year-prev') ? 'light-green' : 'black'" v-on:click="makeDate('year-prev')">Предыдущий год</v-btn>
        </v-sheet>
      </template>
      <template #action-buttons>
        <v-btn variant="text" density="compact" color="deep-orange" block class="ma-1 justify-space-between" flat rounded="xl" v-if="range" v-on:click="clearDate()">
          <template v-slot:append>
            <v-icon :icon="['fas', 'trash']" />
          </template>
          ОЧИСТИТЬ
        </v-btn>
      </template>
    </VueDatePicker>
  </v-sheet>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "GrdnCalendar",
  props: {
    hidePeriods: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    weekPicker: {
      type: Boolean,
      required: false,
      default() {
        return false
      },
    },
    title: {
      required: false,
      type: String
    },
    modelValue: {
      type: [String, Object, null],
      required: true
    },
    range: {
      type: Boolean,
      default() {
        return false
      },
      required: false
    }
  },
  computed: {
    result: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  beforeMount() {
    this.preGenRules()
  },
  data() {
    return {
      selected_cal: null,
      selected_btn: null,
      calendar: {
        rules: null
      },
    }
  },
  methods: {
    clearDate: function () {
      this.result = null
      this.selected_cal = null
      this.selected_btn = null
    },
    preGenRules: function () {
      if (this.range === true) {
        this.calendar.rules = [
          {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          },
          {
            hours: 23,
            minutes: 59,
            seconds: 59,
            milliseconds: 999,
          }
        ]
      } else {
        this.calendar.rules = [
          {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          }
        ]
      }
    },
    makeDate: function (range) {
      this.selected_btn = range
      let start, end
      switch (range) {
        case 'm_current':
          start = moment().startOf('month')
          end = moment().endOf('month')
          break;
        case 'm_prev':
          start = moment().subtract(1, 'month').startOf('month')
          end = moment().subtract(1, 'month').endOf('month')
          break;
        case 'q_1':
          start = moment().month(0).startOf('month')
          end = moment().month(0).add(2, 'month').endOf('month')
          break;
        case 'q_2':
          start = moment().month(3).startOf('month')
          end = moment().month(3).add(2, 'month').endOf('month')
          break;
        case 'q_3':
          start = moment().month(6).startOf('month')
          end = moment().month(6).add(2, 'month').endOf('month')
          break;
        case 'q_4':
          start = moment().month(9).startOf('month')
          end = moment().month(9).add(2, 'month').endOf('month')
          break;
        case 'hy_1':
          start = moment().month(0).startOf('month')
          end = moment().month(5).endOf('month')
          break;
        case 'hy_2':
          start = moment().month(6).startOf('month')
          end = moment().month(11).endOf('month')
          break;
        case 'year-now':
          start = moment().startOf('year')
          end = moment().endOf('day')
          break;
        case 'year-prev':
          start = moment().subtract(1, 'years').startOf('year')
          end = moment().subtract(1, 'years').endOf('year')
          break;
      }

      this.selected_cal = [start, end]
      this.result = {
        start: start.format("YYYY-MM-DD[T]HH:mm:ss"),
        end: end.format("YYYY-MM-DD[T]HH:mm:ss")
      }

    },
    formatDate: function (date) {
      if (this.range || this.weekPicker) {
        if (date && date.length === 2) {
          const s_d = date[0].getDate()
          const s_m = date[0].getMonth() + 1
          const s_y = date[0].getFullYear()

          const f_d = date[1].getDate()
          const f_m = date[1].getMonth() + 1
          const f_y = date[1].getFullYear()

          return `С ${s_d}.${s_m}.${s_y} по ${f_d}.${f_m}.${f_y}`;
        } else {
          return 'Выберите второе число'
        }
      } else {
        if (date) {
          const d = date.getDate()
          const m = date.getMonth() + 1
          const y = date.getFullYear()

          return `${d}.${m}.${y}`;
        }
      }

    },
    handleDate: function (modelData) {
      if (this.range || this.weekPicker) {
        this.result = {
          start: moment(modelData[0]).format("YYYY-MM-DD[T]00:00:00"),
          end:   moment(modelData[1]).format("YYYY-MM-DD[T]23:59:59")
        }
      } else {
        this.result = moment(modelData).format("YYYY-MM-DD[T]00:00:00")
      }

    },
    isSelected: function (range) {
      let start, end = null
      switch (range) {
        case 'm_current':
          start = moment().startOf('month')
          end = moment().endOf('month')
          break;
        case 'm_prev':
          start = moment().subtract(1, 'month').startOf('month')
          end = moment().subtract(1, 'month').endOf('month')
          break;
        case 'q_1':
          start = moment().month(0).startOf('month')
          end = moment().month(0).add(2, 'month').endOf('month')
          break;
        case 'q_2':
          start = moment().month(3).startOf('month')
          end = moment().month(3).add(2, 'month').endOf('month')
          break;
        case 'q_3':
          start = moment().month(6).startOf('month')
          end = moment().month(6).add(2, 'month').endOf('month')
          break;
        case 'q_4':
          start = moment().month(9).startOf('month')
          end = moment().month(9).add(2, 'month').endOf('month')
          break;
        case 'hy_1':
          start = moment().month(0).startOf('month')
          end = moment().month(5).endOf('month')
          break;
        case 'hy_2':
          start = moment().month(6).startOf('month')
          end = moment().month(11).endOf('month')
          break;
        case 'year-now':
          start = moment().startOf('year')
          end = moment().endOf('day')
          break;
        case 'year-prev':
          start = moment().subtract(1, 'years').startOf('year')
          end = moment().subtract(1, 'years').endOf('year')
      }
      start = start.format("YYYY-MM-DD[T]HH:mm:ss")
      end = end.format("YYYY-MM-DD[T]HH:mm:ss")

      if (!this.hidePeriods) {
        return this.result && this.result.start === start && this.result.end === end
      }


    },
  }
}
</script>

<style>
.dp__theme_light {
  --dp-cell-size: 40px !important;
  --dp-border-radius: 0 !important;
  --dp-primary-color: #8BC34A !important;
  --dp-primary-disabled-color: #DCEDC8 !important;
  --dp-border-color: rgb(139, 195, 74) !important;
  --dp-border-color-hover: rgb(139, 195, 74) !important;
  --dp-border-color-focus: rgb(139, 195, 74) !important;
}
</style>
